import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import memoizeOne from 'react-utils/memoizeOne';
import { getPortalId, getProjectName } from '../../../common/utils';
export const getIframeSrc = memoizeOne(() => {
  const portalId = getPortalId();
  const hostAppName = encodeURIComponent(getProjectName());
  const hostAppPathName = encodeURIComponent(window.location.pathname);
  const env = enviro.deployed() ? 'app' : 'local';
  const origin = getFullUrl(env);
  const params = new URLSearchParams({
    hostAppName,
    pathname: hostAppPathName
  });
  return `${origin}/chatspot-widget-ui/${portalId}?${params.toString()}`;
});